export const getters = {
  eventTypeList: (state) => state.eventTypeList,
  createEventTypeSuccess: (state) => state.createEventTypeSuccess,
  updateEventTypeSuccess: (state) => state.updateEventTypeSuccess,
  deleteEventTypeSuccess: (state) => state.deleteEventTypeSuccess,
  eventList: (state) => state.eventList,
  createEventSuccess: (state) => state.createEventSuccess,
  updateEventSuccess: (state) => state.updateEventSuccess,
  deleteEventSuccess: (state) => state.deleteEventSuccess,
  eventOccurrenceCalendarList: (state) => state.eventOccurrenceCalendarList,
  eventOccurrenceCalendarListCancelToken: (state) => state.eventOccurrenceCalendarListCancelToken,
  eventOccurrenceCalendarProgress: (state) => state.eventOccurrenceCalendarProgress,
};
